import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    risks: [],
    list: [],
    prevent: 1,
};

const faSlice = createSlice({
    name: "pkzfa",
    initialState,
    reducers: {
        fill(state, action) {
            state.risks = action.payload.risks;
            state.list = action.payload.frauds.data;
            state.prevent = action.payload.prevent;
        }
    }
})

export const { fill } = faSlice.actions;
export default faSlice.reducer;